<template>
  <div>
    <div id="tempdraw111">
      <!-- <div id="tempdraw"></div> -->
    </div>

    <div style="padding: 10px 0 0 10px">
      图表放大比例：
      <RadioGroup v-model="baifenbi" @on-change="changeBai">
        <Radio :label="100">100%</Radio>
        <Radio :label="200">200%</Radio>
        <Radio :label="400">400%</Radio>
        <Radio :label="800">800%</Radio>
        <Radio :label="1600">1600%</Radio>
        <Radio :label="3200">3200%</Radio>
      </RadioGroup>
    </div>
  </div>
</template>
<script>
var chart;
export default {
  data() {
    return {
      no: true,
      baifenbi: 100,
      list1: [
        /* {
          value: ["2023-01-03 00:10:58", 12, "关", 0, 59.43],
        },
        {
          value: ["2023-01-03 01:10:58", -3, "关", 0, 59.43],
        },
        {
          value: ["2023-01-03 02:10:58", -7, "关", 0, 59.43],
        },
        {
          value: ["2023-01-03 03:10:58", 11, "关", 0, 59.43],
        }, */
      ],
      list2: [
        /* {
          value: ["2023-01-03 00:10:58", 5, "关", 0, 19.43],
        },
        {
          value: ["2023-01-03 01:10:58", -9, "关", 0, 19.43],
        },
        {
          value: ["2023-01-03 02:10:58", 2, "关", 0, 19.43],
        },
        {
          value: ["2023-01-03 03:10:58", 8, "关", 0, 19.43],
        }, */
      ],
      list3: [],
      list4: [],
    };
  },
  methods: {
    reData(list1, list2, list3, list4) {
      this.list1 = list1;
      this.list2 = list2;
      this.list3 = list3;
      this.list4 = list4;
      var length = this.list1.length;
      if (length >= 0 && length < 600) {
        this.baifenbi = 100;
      } else if (length >= 600 && length < 1500) {
        this.baifenbi = 200;
      } else if (length >= 1500) {
        this.baifenbi = 400;
      }
      this.draw();
    },
    draw() {
      var jiange = 24;
      if (this.baifenbi > 0 && this.baifenbi <= 400) {
        jiange = 24;
      } else if (this.baifenbi > 400 && this.baifenbi <= 1600) {
        jiange = 12;
      } else if (this.baifenbi > 1600 && this.baifenbi <= 3200) {
        jiange = 6;
      }
      document.getElementById("tempdraw111").innerHTML =
        '<div id="tempdraw" style="width:' + this.baifenbi + '%"></div>';
      setTimeout(() => {
        var tt = document.getElementById("tempdraw");
        chart = this.echarts.init(tt);
        this.option = {
          backgroundColor: "",
          /* title: {
              text: "温度-时间图像",
            }, */
          color: ["red", "blue", "green", "black"],
          grid: {
            x: 40,
            y: 60,
            x2: 30,
            y2: 50, //距离下边的距离
          },
          legend: {
            left: 40, //图例组件离右边的距离
            top: 30,
            // orient: "vertical", //布局  纵向布局
            orient: "horizontal", //布局  纵向布局
            width: 350, //图行例组件的宽度,默认自适应
            x: "top", //图例显示在右边
            itemWidth: 10, //图例标记的图形宽度
            itemHeight: 10, //图例标记的图形高度
            textStyle: {
              //图例文字的样式
              color: "#333",
              fontSize: 12,
            },
          },
          tooltip: {
            trigger: "axis",
            formatter(params) {
              var ad = params[1];
              params = params[0];

              var adv;
              if (ad != undefined) {
                adv = ad.value[1];
              } else {
                adv = "无";
              }
              return (
                '<div style="padding:6px;color:#fff">' +
                params.value[0] +
                "<br>温度：" +
                params.value[1] +
                "℃" +
                "</div>"
              );
              //return "当前时间：" +params.value[0] + "<br>剩余油量：" + params.value[1]+ "<br>录入油量：" + adv;
            },
            axisPointer: {
              animation: false,
            },
          },
          /* dataZoom: [
              {
                type: "inside",
                //type: "slider",
                //yAxisIndex:[0],
                //xAxisIndex:[0],
                start: 0, //放大起点
                //end: this.end(list),
                end: 100, //放大终点
                //startValue:10,
                //zoomLock:true
              },
            ] ,*/
          xAxis: {
            type: "time",
            minInterval: 1,
            maxInterval: 3600 * jiange * 1000,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              name: "第一路",
              type: "line",
              data: this.list1,
              connectNulls: true,
              // 设置折线弧度，取值：0-1之间
              smooth: 0,
              // 设置折线上圆点大小
              symbolSize: 1,
              showAllSymbol: true,
              itemStyle: {
                normal: {
                  // color: "#6cb041",
                  lineStyle: {
                    width: 2, //设置线条粗细
                  },
                },
              },
              /* areaStyle: {
                  //color: "#ff7c25",
                  opacity: "0.3",
                  //shadowColor: "#000",
                  // shadowBlur: 50,
                  //shadowOffsetX:0,
                  // shadowOffsetY:-10
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#ffc490",
                    },
                    {
                      offset: 1,
                      color: "#FFF",
                    },
                  ]),
                }, */
            },
            {
              name: "第二路",
              type: "line",
              data: this.list2,
              connectNulls: true,
              // 设置折线弧度，取值：0-1之间
              smooth: 0,
              // 设置折线上圆点大小
              symbolSize: 1,
              showAllSymbol: true,
              itemStyle: {
                normal: {
                  // color: "#6cb041",
                  lineStyle: {
                    width: 2, //设置线条粗细
                  },
                },
              },
              /* areaStyle: {
                  //color: "#ff7c25",
                  opacity: "0.3",
                  //shadowColor: "#000",
                  // shadowBlur: 50,
                  //shadowOffsetX:0,
                  // shadowOffsetY:-10
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#ffc490",
                    },
                    {
                      offset: 1,
                      color: "#FFF",
                    },
                  ]),
                }, */
            },
            {
              name: "第三路",
              type: "line",
              data: this.list3,
              connectNulls: true,
              // 设置折线弧度，取值：0-1之间
              smooth: 0,
              // 设置折线上圆点大小
              symbolSize: 1,
              showAllSymbol: true,
              itemStyle: {
                normal: {
                  // color: "#6cb041",
                  lineStyle: {
                    width: 2, //设置线条粗细
                  },
                },
              },
              /* areaStyle: {
                  //color: "#ff7c25",
                  opacity: "0.3",
                  //shadowColor: "#000",
                  // shadowBlur: 50,
                  //shadowOffsetX:0,
                  // shadowOffsetY:-10
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#ffc490",
                    },
                    {
                      offset: 1,
                      color: "#FFF",
                    },
                  ]),
                }, */
            },
            {
              name: "第四路",
              type: "line",
              data: this.list4,
              connectNulls: true,
              // 设置折线弧度，取值：0-1之间
              smooth: 0,
              // 设置折线上圆点大小
              symbolSize: 1,
              showAllSymbol: true,
              itemStyle: {
                normal: {
                  // color: "#6cb041",
                  lineStyle: {
                    width: 2, //设置线条粗细
                  },
                },
              },
              /* areaStyle: {
                  //color: "#ff7c25",
                  opacity: "0.3",
                  //shadowColor: "#000",
                  // shadowBlur: 50,
                  //shadowOffsetX:0,
                  // shadowOffsetY:-10
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#ffc490",
                    },
                    {
                      offset: 1,
                      color: "#FFF",
                    },
                  ]),
                }, */
            },
          ],
        };
        chart.setOption(this.option, true); //true重绘
      }, 200);
    },
    changeBai(v) {
      this.draw();
    },
  },
  //调用
  mounted() {
    //this.drawBar("olinow");
    this.draw();
  },
  destroyed() {},
};
</script>
<style>
#tempdraw111 {
  width: calc(100% - 20px);
  height: 300px;
  overflow: auto;
  background: #d4dfe9;
  margin: 0 10px;
}
#tempdraw {
  height: 280px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/temp/tempDraw.vue